import { useEffect, useMemo, useRef, useState } from "react";
import { tamTamyLanguagesMap } from "../utils/lang";

const useAppLanguage = (defaultLabels, userLanguage, app, unloggedLanguage = null) => {
  const loadedLabels = useRef();
  const [appLang, setAppLang] = useState();
  const [labels, setLabels] = useState({});

  const languages = useMemo(
    () =>
      [
        { value: "en", label: defaultLabels?.WELFARE_LANG_EN || "EN" },
        { value: "it", label: defaultLabels?.WELFARE_LANG_IT || "IT" },
        { value: "fr", label: defaultLabels?.WELFARE_LANG_FR || "FR" },
        { value: "es", label: defaultLabels?.WELFARE_LANG_ES || "ES" },
        { value: "pt", label: defaultLabels?.WELFARE_LANG_PT || "PT" },
      ].filter((lang) =>
        unloggedLanguage
          ? true
          : app
          ? app?.translatedTitle?.[tamTamyLanguagesMap[lang.value]]
          : true
      ),
    [defaultLabels, app, unloggedLanguage]
  );

  useEffect(() => {
    if (unloggedLanguage || userLanguage) {
      const newLang =
        languages?.find((lang) =>
          unloggedLanguage ? lang.value === unloggedLanguage : lang.value === userLanguage
        ) || languages?.[0];
      // console.log("Updating lang", newLang?.value);
      setAppLang(newLang);
    }
  }, [languages, userLanguage, unloggedLanguage, app]);

  useEffect(() => {
    if (loadedLabels.current !== appLang?.value) {
      const loadLangLabels = async (lang) => {
        loadedLabels.current = lang;
        try {
          const response = await fetch(`/bff/translation?locale=${lang}`, {
            headers: {
              Accept: "*/*",
            },
          });
          if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
          }
          const result = await response.json();
          const cleanResult = Object.fromEntries(
            Object.entries(result).filter(([_key, value]) => value !== "-")
          );
          const mergedLabels = {
            ...defaultLabels,
            ...cleanResult,
            _LANGUAGE: lang,
          };
          setLabels(mergedLabels);
        } catch (err) {
          console.error(err);
        }
      };
      if (Object.entries(defaultLabels).length > 0 && appLang) {
        if (appLang?.value === "en") {
          loadedLabels.current = "en";
          setLabels({ ...defaultLabels, _LANGUAGE: "en" });
        } else {
          loadLangLabels(appLang.value);
        }
      }
    }
  }, [defaultLabels, appLang]);

  return { appLang, setAppLang, languages, labels };
};

export default useAppLanguage;
